import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { Subscription, merge } from 'rxjs';

import { DASHBOARDS, DashboardEntry, getDashboardPermissions, isDashboardHidden, isDashboardVisibleInZone, isDashboardVisibleInZoneType } from '../../dashboardv2/dashboards-list';
import { BrandingService } from '../../services/branding.service';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'app-dashboards-card',
  templateUrl: './dashboards-card.component.html',
  styleUrl: './dashboards-card.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    BreadcrumbModule,
    RouterLink,
  ],
})
export class DashboardsCardComponent implements OnInit, OnDestroy {

  home: MenuItem = { icon: 'pi pi-home', routerLink: '/home' };

  breadcrumb: MenuItem[] = [
    { label: 'Reports', routerLink: '/reports' },
    { label: 'Dashboards' },
  ];

  visibleDashboards: DashboardEntry[] = [];

  private zoneSub: Subscription | undefined;

  constructor(
    private branding: BrandingService,
    private permissionService: PermissionService,
  ) {}

  ngOnInit(): void {
    // Requirement: recompute on zone change AND on permission change. The
    // branding query delivers the new zone's permissions *after* currentZone
    // emits, so a zone-only subscription builds the list from the previous
    // zone's permissions and never revisits it. Both sources replay their
    // current value on subscribe, so this also covers the initial render.
    this.zoneSub = merge(
      this.branding.currentZone(),
      this.permissionService.watch(),
    ).subscribe(() => this.recompute());
  }

  ngOnDestroy(): void {
    this.zoneSub?.unsubscribe();
  }

  private recompute(): void {
    const zone = this.branding.currentZone().value;
    const zoneId = zone?.id;
    const zoneType = zone?.type;
    this.visibleDashboards = DASHBOARDS.filter((d) => {
      if (isDashboardHidden(d)) { return false; }
      const perms = getDashboardPermissions(d);
      if (perms.length && !perms.every((p) => this.permissionService.checkPermission(p))) { return false; }
      if (!isDashboardVisibleInZone(d, zoneId)) { return false; }
      if (!isDashboardVisibleInZoneType(d, zoneType)) { return false; }
      return true;
    });
  }
}